<template>
    <v-container fluid class="fill-height pa-0" width="100%">
        <v-card min-height="100vh" color="white" width="100%">
            <v-toolbar color="amber">
                <v-btn icon @click="Close"> <v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title class="font-weight-black" v-if="edit == true">Edit User</v-toolbar-title>
                 <v-toolbar-title class="font-weight-black" v-else>New User</v-toolbar-title>
                    <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-switch v-model="statusHere" :label="statusHere == true ? 'Active': 'In Active'" :value="true" color="black" class="mr-5 mt-5"></v-switch>
                    <v-btn color="black" class="amber--text" @click="save()" :loading="isLoading">Save</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-form class="pa-5">
                <v-row dense>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="name" label="Name" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field type="text" v-model="company" label="Company Name" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field type="email" v-model="email" label="Email" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="phone" label="Phone" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-select :items="['admin','editor','analyser','broker','custmor']" v-model="role" label="Select Role" outlined color="amber"></v-select>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-select item-color='amber' :items="productData" item-text="name" item-value="id" multiple v-model="product" label="Select Product" outlined color="amber"></v-select>
                    </v-col>

                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="username" label="Username" outlined color="amber"></v-text-field>
                    </v-col>
                    <v-col md=6 sm=6 cols=12 class="py-0">
                        <v-text-field v-model="password" label="Password" outlined color="amber"></v-text-field>
                    </v-col>
                </v-row>
            </v-form> 
        </v-card>
        <span style="display:none;">{{checkfetch}}</span>
    </v-container>
</template>

<script>
import { SERVER_API } from "../../API/";
export default {
    created(){
        window.addEventListener('keyup', event => {
            if(event.which === 27){
                this.Close();
            }
            if(event.which === 13){
                this.Save();
            }
        })
    },
    mounted(){
        this.fetchProduct();
    },
    props:['id','edit'],
    data(){
        return{
            name:'',
            company:'',
            email:'',
            phone:'',
            username:'',
            role:'',
            product:[],
            unit:'',
            password:'',
            status:0,
            statusHere:false,
            isLoading:false,
            productData:[],
        }
    },
    watch:{
        statusHere(val){
            if(val == true){
                this.status = 1;
            }else{
                this.status = 0;
            }
        }
    },
    computed:{
        checkfetch(){
            return this.fetchById();
        }
    },
    methods:{
         reset(){
            this.name = '';
            this.email = '';
            this.company = '';
            this.phone = '';
            this.username = '';
            this.role = '';
            this.product = [];
            this.unit = '';
            this.password = '';
        },
        Close(){
            this.reset()
            this.id = '';
            this.edit="";
            this.$emit('Close',false);
        },
        async fetchProduct(){
            const response =  await this.$http.get(SERVER_API+'/product/records');
            this.productData = response.data.data;
        },
        async fetchById(){
            if(this.edit == true){
                const response = await this.$http.get(SERVER_API+'/user/byid/'+this.id);
                this.name = response.data.data.name;
                this.company = response.data.data.company;
                this.email = response.data.data.email;
                this.phone = response.data.data.phone;
                this.username = response.data.data.username;
                this.role = response.data.data.role;
                this.product = response.data.data.product;
                this.unit = response.data.data.unit;
                this.status = response.data.data.status;    
                this.statusHere = response.data.data.status == 0 ? false : true;
                this.product = this.product.split(',').map(function(item) {
                    return Number(item);
                });
            }
        },
        async save(){
            if(this.edit == true){
                try{
                    this.isLoading = true;
                    const response = await this.$http.put(SERVER_API+'/user/update',{
                        id:this.id,
                        name: this.name,
                        email: this.email,
                        company: this.company,
                        phone: this.phone,
                        username: this.username,
                        role: this.role,
                        product: this.product,
                        unit: this.unit,
                        password: this.password,
                        status: this.status,
                    });
                    this.isLoading = false;
                    this.$emit('Response',response.data);
                }catch(error){
                    this.isLoading = false;
                    this.$emit('Response',error);
                }
            }else{
                try{
                    this.isLoading = true;
                    const response = await this.$http.post(SERVER_API+'/user/create',{
                        name: this.name,
                        email: this.email,
                        company: this.company,
                        phone: this.phone,
                        username: this.username,
                        role: this.role,
                        product: this.product,
                        unit: this.unit,
                        password: this.password,
                        status: this.status,
                    });
                    this.reset();
                    this.isLoading = false;
                    this.$emit('Response',response.data);
                }catch(error){
                    this.isLoading = false;
                    this.$emit('Response',error);
                }
            }
        }
    }

}
</script>

<style>

</style>